module.exports = __webpack_public_path__ + "static/media/elcano_6.ab88cb13.png";